<template>
  <div class="login-container">
    <img :src="logoImg" alt="logo" class="logo" />
    <div class="title-box">
      <img :src="titleImg" alt="title" />
    </div>
    <div class="middle-wrap">
      <div class="chain-display"></div>
      <div class="login-box">
        <div class="title">
          <div class="large">
            <span>{{ g_Config.CHAIN_NAME }}</span
            >{{ g_Config.TYPE }}
          </div>
          <div class="small">{{ g_Config.DESCRIPTION }}</div>
        </div>
        <div class="tit">欢迎登录</div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          label-position="left"
          :hide-required-asterisk="true"
          label-width="0"
        >
          <el-form-item prop="username" label="">
            <el-input
              v-model.trim="loginForm.username"
              size="medium"
              class="textStyle"
              placeholder="请输入您的账号"
              @keyup.enter.native="handleLogin"
            >
              <span slot="prefix" class="username-icon"></span>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="">
            <el-input
              v-model.trim="loginForm.password"
              type="password"
              size="medium"
              placeholder="请输入密码"
              @keyup.enter.native="handleLogin"
            >
              <span slot="prefix" class="password-icon"></span>
            </el-input>
          </el-form-item>
          <el-form-item prop="captchaVal" label="" class="validate-item">
            <div class="validate-code">
              <el-input
                v-model="loginForm.captchaVal"
                class="code-input"
                size="medium"
                placeholder="请输入验证码"
                @keyup.enter.native="handleLogin"
              ></el-input>
              <div class="identify-image" @click="changeIdentifyImgFn">
                <img :src="identifyCode" alt="">
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mem-pw-item">
            <el-checkbox v-model="checked" class="mem-password">记住密码</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="loadingStatus"
              class="submit-btn"
              size="medium"
              @click.native.prevent="handleLogin"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="copyright-box">
      <span class="company">CopyRight©青岛海检集团有限公司</span>
      <span>鲁ICP备14014787号-8</span>
    </div>
    <el-dialog
      title="license验证"
      top="35vh"
      :visible.sync="showLicenseDialog"
      class="verify-license-dialog common-dialog"
    >
      <el-input v-model="licenseContent" placeholder="请输入license"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateLicenseFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { mapActions } from 'vuex'
import { handleDecrpty, handleEncrpty } from '@/utils/sm4Func'
import { setCookie, getCookie } from '@/utils/cookie'
import errCode from '@/utils/errorCode'
import logoImg from '@/assets/images/login/logo.png'
import titleImg from '@/assets/images/login/title.png'
const Base64 = require('js-base64').Base64
export default {
  name: 'Login',
  mixins: [adaptation],
  adaptationVarsDefine: {
    fontSizeMin: 16,
    fontSizeMax: 40,
    contentWidth: 106,
    contentHeight: 40,
    borderRadius: 4
  },
  data() {
    return {
      logoImg,
      titleImg,
      loadingStatus: false,
      loginForm: {
        username: '',
        password: '',
        captchaVal: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message: '请输入账号' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        captchaVal: [{ required: true, trigger: 'blur', message: '请输入验证码' }]
      },
      code: '',
      captchaId: '',
      checked: false,
      btns: {},
      menus: {},
      allFuncs: {},

      identifyCodes: '1234567890',
      identifyCode: '',
      showLicenseDialog: false,
      licenseContent: '',
      adaptationVars: {
        fontSizeMin: 16,
        fontSizeMax: 40,
        contentWidth: 106,
        contentHeight: 40,
        borderRadius: 4
      }
    }
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let enusername = getCookie('cbaas_username')
    let username = decodeURIComponent(atob(enusername))
    let encryptedCookieValue = getCookie('cbaas_password')
    let password = decodeURIComponent(atob(encryptedCookieValue))
    // let password = decodeURIComponent(atob(getCookie('cbaas_password')));
    // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.loginForm.username = username
      this.loginForm.password = password
      this.checked = true
    }
  },
  mounted() {
    document.getElementById('page-preloading').style.display = 'none'
    this.identifyCode = ''
    this.changeIdentifyImgFn()
  },
  methods: {
    changeIdentifyImgFn() {
      this.$apis.app.getCaptcha().then(res => {
        if(res?.data && res?.data?.base64s) {
          this.identifyCode = res.data.base64s
          this.captchaId = res.data.id
        }
      })
    },
    ...mapActions(['updateResourceList']),
    // makeCode(o, l) {
    //   for (var a = [], i = 0; i < l; i++) {
    //     a[i] = o[Math.floor(Math.random() * o.length)]
    //   }
    //   this.identifyCode = a.join('')
    // },
    loginFn() {
      let loginParam = {
        username: handleEncrpty(this.loginForm.username),
        password: handleEncrpty(this.loginForm.password), // sm4加密处理
        captchaId: this.captchaId,
        captchaVal: this.loginForm.captchaVal
      }
      this.$apis.app
        .login(loginParam)
        .then(res => {
          if (res.data) {
            this.handleJump(res.data)
          }
          this.loadingStatus = false
        })
        .catch(err => {
          if (err.response['data']['errors'][0]['code']) {
            this.$message.error(errCode[err.response['data']['errors'][0]['code']])
            this.changeIdentifyImgFn()
          }
          this.loadingStatus = false
        })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loadingStatus = true

          this.showLicenseDialog = false
          this.$apis.app
            .checkLicense()
            .then(res => {
              if (res.data.IsOk == true) {
                this.showLicenseDialog = false
                let time = res.data?.Licence?.ValidUntil
                localStorage.setItem('cbaas_system_valid_time', new Date(time).toLocaleString())
                this.loginFn()
              } else {
                this.showLicenseDialog = true
                this.loadingStatus = false
              }
            })
            .catch(error => {
              this.loadingStatus = false
              this.showLicenseDialog = true
              //this.$message.warning('登录错误:' + error.message)
            })
        } else {
          this.$message.warning('请填写登录信息')
          this.loadingStatus = false
          return false
        }
      })
    },
    async handleJump(res) {
      const token = res.token
      res.username = handleDecrpty(res.username)
      localStorage.setItem('cbaas_system_Token', token)
      localStorage.setItem('cbaas_system_userInfo', JSON.stringify(res))
      localStorage.setItem('cbaas_userinfo_islogin', '1')
      this.setUserInfo() //记住密码
      await this.handleAuth({ roleID: res.roleID })

      const baseUrl = this.$utils.getBaseUrl()
      //this.$router.replace('/home')
      setTimeout(() => {
        location.href = `${baseUrl}#/home`
        window.location.reload()
      }, 200)
    },
    handleAuth(param) {
      return new Promise((resolve, reject) => {
        this.$apis.system.getRoleAuth(param).then(res => {
          if (res.data) {
            this.diffAuth(res.data)
            localStorage.setItem('cbaas_system_btns_auth', JSON.stringify(this.btns))
            localStorage.setItem('cbaas_system_menus_auth', JSON.stringify(this.menus))
            localStorage.setItem('cbaas_system_all_auth', JSON.stringify(this.allFuncs))
            resolve(true)
          }
        })
      })
    },
    diffAuth(data) {
      data.forEach(ele => {
        if (ele.IsChecked && ele.type === 'menu') {
          this.menus[ele.ID] = ele.ID
        }
        if (ele.IsChecked && ele.type === 'button') {
          this.btns[ele.ID] = ele.ID
        }
        this.allFuncs[ele.ID] = ele.ID
        if (!this.$utils.isEmpty(ele.Children)) {
          this.diffAuth(ele.Children)
        }
      })
    },
    //存储用户信息
    setUserInfo() {
      if (this.checked) {
        setCookie('cbaas_username', this.loginForm.username)
        //加密密码
        // let passWord = btoa(encodeURIComponent(this.loginForm.password));
        setCookie('cbaas_password', this.loginForm.password)
        // localStorage.setItem('cbaas_password', passWord)
      } else {
        setCookie('cbaas_username', '')
        setCookie('cbaas_password', '')
      }
    },

    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // refreshCode() {
    //   this.identifyCode = ''
    //   this.makeCode(this.identifyCodes, 4)
    // },
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
    //   }
    // },
    // 输入license验证
    updateLicenseFn() {
      this.$apis.app
        .updateLicense({
          content: this.licenseContent
        })
        .then(res => {
          this.showLicenseDialog = false
          this.loginFn()
        })
        .catch(err => {
          this.$message.error('license验证失败')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@import '../../assets/font/fonts.css';
.login-container {
  @include adaptation(
    (
      --logo-size: 152px,
      --logo-pos: 57px,
      --logo-top: 43px,
      --chain-display-width: 894px,
      --chain-display-height: 733px,
      --login-box-padding: 32px 36px,
      --login-box-width: 400px,
      --login-box-height: 440px,
      --title-large-font-size: 36px,
      --title-large-line-height: 38px,
      --title-large-letter-space: 0.16px,
      --title-small-font-size: 14px,
      --title-small-line-height: 22px,
      --tit-font-size: 20px,
      --tit-line-height: 24px,
      --login-box-shadow-size: 0px 24px 28px,
      --input-line-height: 40px,
      --code-input-width: 205px,
      --identify-image-width: 106px,
      --identify-image-height: 40px,
      --submit-btn-height: 26px,
      --input-padding-left: 44px,
      --login-box-margin-right: 70px,
      --title-img-padding: 104px,
      --title-box-height: 66px
    )
  );
  position: relative;
  width: 100%;
  height: 100vh;
  background: url('~@/assets/images/login/bg1.png') no-repeat center;
  background-size: cover;

  .logo {
    position: absolute;
    top: var(--logo-top);
    left: var(--logo-pos);
    width: var(--logo-size);
  }
  .title-box {
    width: 100%;
    height: var(--title-box-height);
    position: absolute;
    top: var(--title-img-padding);
    text-align: center;
    img {
      width: 100%;
      max-width: 1302px;
      height: auto;
    }
  }

  .verify-license-dialog {
    /deep/ .el-dialog {
      width: var(--common-dialog-width);

      .el-dialog__body {
        margin-bottom: var(--base-size-16);
      }
    }
  }

  .chain-display {
    width: var(--chain-display-width);
    height: var(--chain-display-height);
    //background: url('~@/assets/images/login/frame-img.png') no-repeat center;
    //background-size: 100% 100%;
  }

  .middle-wrap {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    width: 100%;
    height: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .login-box {
      width: var(--login-box-width);
      height: var(--login-box-height);
      border-radius: var(--base-border-radius);
      padding: var(--login-box-padding);
      background: rgba(10, 34, 97, 0.5);
      box-shadow: var(--login-box-shadow-size) rgba(0, 10, 27, 0.24);
      margin-right: var(--login-box-margin-right);

      .title {
        text-align: center;
        .large {
          font-size: var(--title-large-font-size);
          color: #fff;
          font-family: 'Youshe', sans-serif;
          line-height: var(--title-large-line-height);
          letter-spacing: var(--title-large-letter-space);
        }

        .small {
          color: rgba(255, 255, 255, 0.6);
          font-size: var(--title-small-font-size);
          line-height: var(--title-small-line-height);
          margin-top: var(--base-size-8);
        }
      }

      .tit {
        color: #fff;
        font-size: var(--tit-font-size);
        font-weight: 500;
        line-height: var(--tit-line-height);
        margin-top: var(--base-size-24);
        margin-bottom: var(--base-size-20);
        text-align: center;
      }

      .el-input {
        /deep/ {
          .el-input__inner {
            border-radius: var(--base-border-radius);
            border: var(--base-border-width) solid rgba(155, 183, 255, 0.5);
            background: rgba(10, 34, 97, 0.5);
            line-height: var(--input-line-height);
            height: var(--input-line-height);
            padding-left: var(--input-padding-left);
            color: #fff;
            font-size: var(--base-font-size-medium);

            &::placeholder {
              color: rgba(255, 255, 255, 0.6);
            }
          }

          .el-input__prefix {
            display: flex;
            align-items: center;
            left: var(--base-size-16);
          }
        }

        .password-icon {
          background: url('~@/assets/images/login/password-icon.png') no-repeat center;
          width: var(--base-size-16);
          height: var(--base-size-16);
          background-size: 100%;
          display: inline-block;
        }

        .username-icon {
          background: url('~@/assets/images/login/username-icon.png') no-repeat center;
          width: var(--base-size-16);
          height: var(--base-size-16);
          display: inline-block;
          background-size: 100%;
        }
      }

      .el-form {
        /deep/ {
          .el-form-item__error {
            padding-top: var(--base-size-4);
            font-size: var(--base-font-size-common);
            line-height: var(--base-size-16);
          }
        }
      }

      .el-form-item {
        margin-bottom: var(--base-size-22);

        &.validate-item {
          margin-bottom: var(--base-size-2);
        }

        &.mem-pw-item {
          margin-bottom: var(--base-size-24);
          margin-top: var(--base-size-12);
        }
      }

      .validate-code {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .code-input {
          width: var(--code-input-width);

          /deep/ {
            .el-input__inner {
              padding-left: var(--base-size-12);
            }
          }
        }

        .identify-image {
          display: inline-block;
          height: var(--identify-image-height);
          width: var(--identify-image-width);
          margin-left: var(--base-size-12);
          background: #f3f2f2;
          border-radius: var(--base-border-radius);
          .s-canvas {
            height: var(--identify-image-height);
          }
        }
      }

      .mem-password {
        color: #fff;
        /deep/ {
          .el-checkbox__inner {
            background-color: rgba(10, 34, 97, 0.5);
            border-color: rgba(155, 183, 255, 0.5);
          }
        }
      }

      .submit-btn {
        width: 100%;
        border-radius: var(--base-border-radius);
        border: none;
        background: rgba(56, 134, 255, 1);
        line-height: var(--submit-btn-height);
        font-size: var(--base-font-size-large);

        &:hover,
        &:focus {
          opacity: 0.8;
        }
      }
    }
  }
  .copyright-box {
    width: 100%;
    position: absolute;
    bottom: var(--tit-font-size);
    text-align: center;
    color: #f1f7ff;
    font-size: var(--base-size-16);
    .company {
      margin-right: var(--base-size-20);
    }
  }
}
</style>
